/**
 * two-letter initials for an avatar fallback: first letter of the first
 * and last whitespace-separated words. collapses to "·" when there's
 * nothing usable (no name and no fallback).
 */
export function initials(
  name: string | null | undefined,
  fallback = ''
): string {
  const source = name?.trim() || fallback
  const parts = source.split(/\s+/).filter(Boolean)
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase() || '·'
}
